import { OrderSource } from "../../../../../../../types";

import type { TFunction } from "i18next";
import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model, t: TFunction) => {
	let content = item?.additionalFields?.initiator?.callSign ?? "";

	if (content === "customer") content = t("client") ?? "";
	if (content === "dispatcher") {
		content = t("order_source.dispatcher") ?? content;
	}
	if (content === "transfer") {
		content = t("settings.interface.colors.groups.transfer") ?? content;
	}

	let backgroundColor: string | undefined;
	if (item && typeof item.source === "string") {
		const [colorOrange, colorGreen] = ["#ffa940", "#73d13d"];
		const colorMap: Partial<Record<OrderSource, string | undefined>> = {
			[OrderSource.DISPATCHER]: colorGreen, // dispatcher
			[OrderSource.PHONE]: content !== "" ? colorGreen : undefined, // dispatcher. Executor dont have phone paramentr source
			[OrderSource.EXECUTOR]: colorOrange,
		};
		backgroundColor = colorMap[item.source] ?? undefined;
	}

	return { content, backgroundColor };
};

export default cellProcessing;
